﻿(function ($) {
    $(function () {
        var $dateTimeInput = $('#datetimepicker');
        if (!$dateTimeInput.length) {
            return;
        }

        // Format: m.d
        var disabledDates = [
            '1.1',
            '5.1',
            '5.17',
            '12.25',
            '12.26'
        ];

        $.datetimepicker.setLocale('no');
        $dateTimeInput.datetimepicker(
            {
                allowTimes: [
                    '09:00',
                    '10:00',
                    '11:00',
                    '12:00',
                    '13:00',
                    '14:00',
                    '15:00',
                ],
                beforeShowDay: function (date) {
                    // disable weekends
                    if (date.getUTCDay() === 0 || date.getUTCDay() === 6) {
                        return [false];
                    }

                    // Disable public static holidays (pun intended)
                    for (var i = 0; i < disabledDates.length; i++) {
                        var disabledDate = new Date(disabledDates[i]);

                        if (disabledDate.getDate() === date.getDate() && disabledDate.getMonth() === date.getMonth()) {
                            return [false];
                        }
                    }

                    return [true];
                }
            });
    });
})(jQuery); 